import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CartDrawer from "@/components/feature/CartDrawer";

export default function NotFound() {
  useEffect(() => {
    document.title = "Página não encontrada | Bozzetti Store";
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center px-4 py-20 text-center">
        <p className="font-body text-sm font-semibold uppercase tracking-[0.3em] text-primary-700">Erro 404</p>
        <h1 className="mt-3 font-heading text-4xl text-foreground-950 md:text-5xl">Página não encontrada</h1>
        <p className="mt-4 max-w-md text-base text-foreground-600">
          O endereço que você abriu não existe ou foi movido. Volte para a loja e continue escolhendo suas peças.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link to="/" className="inline-flex min-h-[48px] items-center justify-center rounded bg-foreground-950 px-8 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700">
            Ir para a página inicial
          </Link>
          <Link to="/produtos" className="inline-flex min-h-[48px] items-center justify-center rounded border border-foreground-950 px-8 text-sm font-semibold text-foreground-950 transition-colors hover:border-primary-700 hover:text-primary-700">
            Ver todos os produtos
          </Link>
        </div>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
